import React from 'react';
import './css/Intro.css';
import SearchFormFunc from '../../SearchForm/SearchFormFunc';
import {
  INTRO_TITLE,
  INTRO_SUBTITLE,
  INTRO_BG_IMAGE,
} from '../../../Utils/Constants/HomePageConstants';
import { HOME_PAGE } from '../../../Utils/Constants/GlobalConstants';
import SearchOptions from '../../SearchOptions/SearchOptions';

function Intro() {
  return (
    <div>
      <div className="h_intro_w">
        <div
          className="h_intro"
          style={{ backgroundImage: `url(${INTRO_BG_IMAGE})` }}
        >
          <div className="containerW">
            <div className="h_intor_line1">{INTRO_TITLE}</div>
            <div className="h_intor_sub wr_text_20">{INTRO_SUBTITLE}</div>
            <SearchOptions />
            <div>
              <SearchFormFunc page={HOME_PAGE} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
